import { ProjectDocTypeVals } from "./ProjectDocTypes";

export const PDFNoteCodeTypeVals = {
  Ordinary: 1,
  Executive: 2,
} as const;

export function getPDFNoteCodeTypeIdsForProjectDocType(docTypeId?: number): number[] {
  if (docTypeId === ProjectDocTypeVals.Executive) {
    return [PDFNoteCodeTypeVals.Executive];
  }
  return [PDFNoteCodeTypeVals.Ordinary];
}
